import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
import { useSocketStore } from '../../stores/socketStore';

interface QuizModeProps {
  onAnswer: (answerId: string) => void;
}

export default function QuizMode({ onAnswer }: QuizModeProps) {
  const { currentQuestion, quizAnswered } = useSocketStore();
  
  if (!currentQuestion) {
    return null;
  }
  
  return (
    <div className="space-y-6">
      {/* Question */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        <div className="flex items-center justify-center gap-2 mb-2">
          <HelpCircle className="w-6 h-6 text-primary-400" />
          <span className="text-dark-400 text-sm uppercase tracking-wide">
            Question {currentQuestion.type === 'title' ? 'Titre' : 
                      currentQuestion.type === 'artist' ? 'Artiste' : 
                      currentQuestion.type === 'year' ? 'Année' : 'Album'}
          </span>
        </div>
        <h2 className="text-2xl font-bold text-white">
          {currentQuestion.question}
        </h2>
      </motion.div>
      
      {/* Options */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
        {currentQuestion.options.map((option, index) => (
          <motion.button
            key={option.id}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => !quizAnswered && onAnswer(option.id)}
            disabled={quizAnswered}
            className={`p-4 rounded-xl text-left transition-all ${
              quizAnswered 
                ? 'opacity-50 cursor-not-allowed' 
                : 'hover:bg-white/10 cursor-pointer hover:scale-105'
            } bg-white/5 border border-white/10`}
          >
            <div className="flex items-center gap-3">
              <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${
                index === 0 ? 'bg-blue-500' :
                index === 1 ? 'bg-green-500' :
                index === 2 ? 'bg-yellow-500' :
                'bg-red-500'
              }`}>
                {option.id.toUpperCase()}
              </span>
              <span className="text-lg">{option.text}</span>
            </div>
          </motion.button>
        ))}
      </div>
      
      {quizAnswered && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center text-dark-400"
        >
          Réponse envoyée ! Attendez la fin du round...
        </motion.p>
      )}
    </div>
  );
}
